import src from "IMAGE";
export default { src, width: 800, height: 400, blurWidth: 0, blurHeight: 0};
